// Agregaciones para las visualizaciones del portal (series y conteos).
// Funciones puras: reciben `reg` (registros ya enriquecidos con _sla/_av)
// y devuelven series listas para los componentes de gráficas.

const MESES = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic",
];

// Serie mensual (últimos `meses`) a partir de un campo de fecha (ISO yyyy-mm-dd).
// Devuelve [{ label: 'oct', full: '2025-10', value }] en orden cronológico.
export function porMes(reg, campo, meses = 12) {
  const ahora = new Date();
  const claves = [];
  const mapa = {};
  for (let i = meses - 1; i >= 0; i--) {
    const d = new Date(ahora.getFullYear(), ahora.getMonth() - i, 1);
    const k = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    claves.push(k);
    mapa[k] = 0;
  }
  reg.forEach((r) => {
    const iso = r[campo];
    if (iso && mapa[iso.slice(0, 7)] != null) mapa[iso.slice(0, 7)]++;
  });
  return claves.map((k) => {
    const m = parseInt(k.slice(5, 7), 10);
    return { label: MESES[m - 1] || k, full: k, value: mapa[k] };
  });
}
